import { Controller } from 'react-hook-form';
import { toStringOrEmpty } from '../../../../utils/cast';
import type { FieldOptions } from '../../types';
import FormFieldContainer from '../FormFieldContainer';
import { MarkdownEditor } from './MarkdownEditor';
import './markdown-field.scss';

type MarkdownFieldProps = {
    fieldOptions: FieldOptions<'markdown'>;
};

export default function MarkdownField({ fieldOptions }: MarkdownFieldProps): JSX.Element {
    const { name, settings } = fieldOptions;
    const isReadOnly = settings?.readOnly === true;

    return (
        <Controller<Record<string, unknown>, string>
            name={name}
            defaultValue={toStringOrEmpty(settings?.default)}
            rules={{
                required: Boolean(settings?.required),
            }}
            render={({ field: { value, onChange } }) => (
                <FormFieldContainer
                    fieldOptions={fieldOptions}
                    showOverrideCheckbox={false}
                    inline={false}
                    className="w-full"
                >
                    <MarkdownEditor
                        name={name}
                        value={toStringOrEmpty(value)}
                        onChange={onChange}
                        placeholder={settings?.placeholder}
                        isReadOnly={isReadOnly}
                    />
                </FormFieldContainer>
            )}
        />
    );
}
